import * as React from "react";
import { forwardRef } from "react";
const SvgMainMenuHelp = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M6.67207 6.59967C6.86015 6.06501 7.23139 5.61416 7.72003 5.32698C8.20868 5.0398 8.78319 4.93482 9.34181 5.03064C9.90044 5.12646 10.4071 5.41689 10.7721 5.8505C11.1371 6.2841 11.3369 6.83289 11.3361 7.39967C11.3361 8.99967 8.93607 9.79967 8.93607 9.79967M9 13H9.008M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9Z",
	stroke: "#434343",
	strokeWidth: 1.2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgMainMenuHelp);
export default ForwardRef;
